import { useState } from "react";

import { CustomerCareContactModal } from "components/customer-care-contact-modal";
import { RegularContentLoader } from "components/loader";
import { usePoliciesList } from "data/ss-data-hooks";
import SettingsPanelLayout from "pages/settings/common/settings-panel-layout";

import PaperlessItem from "./paperless-item";

export const Paperless = () => {
  const { data, isLoading } = usePoliciesList();
  const [showContactModal, setShowContactModal] = useState(false);

  if (isLoading) {
    return <RegularContentLoader />;
  }

  const policyItems = data?.map((policy) => (
    <PaperlessItem
      key={policy.keystonePolicyId}
      policy={{
        propertyAddress: policy.propertyAddress,
        platformPolicyId: policy.platformPolicyId,
        isCommercial: policy.isCommercial,
      }}
    />
  ));

  return (
    <>
      <SettingsPanelLayout title="Paperless" policyItems={policyItems} />
      <CustomerCareContactModal
        description="We can assist with any questions about billing or your SageSure account."
        handleClose={() => {
          setShowContactModal(false);
        }}
        show={showContactModal}
      />
    </>
  );
};
